import { useContext } from "react";
import { HorizonLayout } from "./layout/HorizonLayout";
import { ChartSection } from "../../layout/ChartSection";
import { RefProvider } from "./store/RefContext";
import { LayoutProvider } from "./store/LayoutContext";
import { LocalStoreProvider } from "./store/LocalStore";
import { StoreContext } from "../../store/Store";
import { model } from "../../layout/models/horizonmodel";

export const Horizon = () => {
  const [store] = useContext(StoreContext);
  const { dimensions } = store;
  return (
    <ChartSection header="" height={dimensions.vh}>
      <LayoutProvider model={model}>
        <RefProvider>
          <LocalStoreProvider>
            <HorizonLayout />
          </LocalStoreProvider>
        </RefProvider>
      </LayoutProvider>
    </ChartSection>
  );
};
